import request from "../utils/request";

/** 待我審核清單 */
export function GET_ApprovalToMe(token, payload) {
  return request.get("/Approval/ToMe", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

/** 我發起的審核 */
export function GET_ApprovalByMe(token, payload) {
  return request.get("/Approval/ByMe", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

/** 審核決議（通過 / 要求修改） */
export function POST_ApprovalDecide(token, payload) {
  return request.post("/Approval/Decide", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}
